// Etiquetas de rol para "Mi Equipo", compartidas por la tabla (desktop) y la
// card (móvil). Módulo propio para no romper react-refresh.
// super_admin = rol máximo del cliente, mostrado como "Administrador"
// (el rol `admin` quedó deprecado — reunión 2026-06-12).
export const ROLE_LABELS: Record<string, string> = {
  super_admin: 'Administrador',
  admin: 'Administrador',
  supervisor: 'Supervisor',
  instructor: 'Instructor',
  employee: 'Empleado',
};
